module.exports = __webpack_public_path__ + "img/3.a90c52f5.png";